import { render, staticRenderFns } from "./NavLinks.vue?vue&type=template&id=20f227d2&scoped=true&"
import script from "./NavLinks.vue?vue&type=script&lang=js&"
export * from "./NavLinks.vue?vue&type=script&lang=js&"
import style0 from "./NavLinks.vue?vue&type=style&index=0&id=20f227d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f227d2",
  null
  
)

export default component.exports